const certificate = {
  // HeroSection
  'certificate.hero.homeLink': 'ホーム',
  'certificate.hero.currentPage': '修了証・認定資格について',
  'certificate.hero.imgAlt': '認定ピンバッジと修了証書の静物',

  // breadcrumb
  'certificate.breadcrumb.home': 'ホーム',
  'certificate.breadcrumb.pricing': '料金・特典',
  'certificate.breadcrumb.current': '修了証・認定資格について',

  // CertificationLevels
  'certificate.levels.label': 'CERTIFICATION LEVELS',
  'certificate.levels.title': '認定資格の3階級',
  'certificate.levels.titleEn': 'Three Certification Tiers',
  'certificate.levels.lead': '各コースの修了実技試験に合格すると、習得を証明する協会認定資格を取得できます。級は三段階に分かれており、学びの深さに応じて段階的に認定されます。認定資格を発行する日本の執事学校として、協会独自の認定バトラー資格を段階に応じて授与しています。',
  'certificate.levels.certNote': '※当協会独自の民間資格です',
  'certificate.levels.courseLabel': '取得コース：',
  'certificate.levels.skillsTitle': '認定スキル領域',
  'certificate.levels.courseLink': 'コース詳細を見る',

  // Requirements
  'certificate.requirements.label': 'REQUIREMENTS',

  // ExamOverview
  'certificate.exam.label': 'PRACTICAL EXAM',

  // AwardItems
  'certificate.award.label': 'WHAT YOU RECEIVE',

  // UsageSection
  'certificate.usage.label': 'HOW TO USE',
  'certificate.usage.title': '資格の活用',
  'certificate.usage.lead': '認定資格は、執事としての専門性を客観的に示すものです。就職・転職時のスキル証明としてご活用いただけます。修了生向けの求人情報提供の仕組みも準備を進めており、キャリア形成を支援します。執事学校で得た認定は、日本における執事資格の客観的な指標としても活用できます。',
  'certificate.usage.point.0.title': '就職・転職時のスキル証明',
  'certificate.usage.point.0.desc': '認定証および認定ピンバッジは、執事としての技能水準を第三者に示す客観的な証明書類としてご活用いただけます。',
  'certificate.usage.point.1.title': '求人情報へのアクセス（準備中）',
  'certificate.usage.point.1.desc': '修了生向けに、協会が把握した執事関連の求人情報を提供する仕組みを予定しています。キャリアの選択肢を広げる情報提供として整備を進めています。',
  'certificate.usage.point.2.title': '信頼性の証明',
  'certificate.usage.point.2.desc': '協会認定資格は、雇用主やクライアントに対し、一定水準以上の技能を有することを示す信頼の指標となります。',
  'certificate.usage.note': '※本資格は就職を保証するものではありません。あくまで技能水準を証明するものであり、就職活動はご自身で行っていただきます。',

  // FAQSection
  'certificate.faq.label': 'FAQ',
  'certificate.faq.title': 'よくあるご質問',
  'certificate.faq.titleEn': 'Frequently Asked Questions',
  'certificate.faq.contactNote': 'その他のご質問は',
  'certificate.faq.contactLink': 'お問い合わせ',
  'certificate.faq.contactSuffix': 'よりお寄せください',

  // CTASection
  'certificate.cta.label': 'NEXT STEP',
  'certificate.cta.title': 'まずはコースからお選びください',
  'certificate.cta.lead': '認定資格の取得を目指す第一歩は、コース選びから。ご自身の目標に合ったコースを、資料請求や個別相談でじっくりお確かめください。',
  'certificate.cta.onlineNote': '※ご相談はオンラインでも承ります',
  'certificate.cta.coursesBtn': 'コースを見る',
  'certificate.cta.brochureBtn': '資料請求はこちら（無料）',
  'certificate.cta.consultBtn': '個別相談を予約する',

  // RelatedPages
  'certificate.related.label': 'LEARN MORE',
  'certificate.related.title': '関連ページ',
  'certificate.related.titleEn': 'Explore Further',
  'certificate.related.arrowLabel': '詳しく見る',

  // footer
  'certificate.footer.lastUpdated': '最終更新: 2026年6月13日',
  'certificate.backToTop.ariaLabel': 'ページの先頭へ戻る',
};

export default certificate;
